import {
  UPDATE_CALCULATED_SCORE,
  UPDATE_IS_REVIEW_SUBMITTED,
  UPDATE_IS_USER_SUBMITTING,
  UPDATE_IS_VALIDATION_ERROR,
  UPDATE_MANDATORY_ANSWERED,
  UPDATE_MANDATORY_COUNT,
  UPDATE_REVIEW_FORM_DRAFT_STATUS,
  UPDATE_REVIEW_TO_ID,
  UPDATE_REVIEW_TO_INFO,
  UPDATE_REVIEW_WRITER_INFO,
  UPDATE_SECTION_DATA,
  UPDATE_SECTION_LIST,
  UPDATE_REVIEW_TABS_DATA,
  UPDATE_SELECTED_REVIEW_TAB,
  UPDATE_IS_FETCHING_REVIEW_FORM_TABS,
  UPDATE_IS_FETCHING_REVIEW_FORM,
  RESET_REVIEW_FORM,
} from "./form.action";

const INITIAL_STATE = {
  // alias - reviewSubmitted
  isReviewSubmitted: null,

  // loading states
  isUserSubmitting: false,
  isFetchingReviewFormTabs: false,
  isFetchingReviewForm: false,

  // Meta of form

  // Draft status
  draftStatus: "",

  // Validation error
  isValidationError: false,

  // alias - review form
  // section list
  // sectionList is array of array
  // if its a section, its id is added at 0th index of a section
  sectionList: null,
  sectionData: null,

  blockInfo: {
    question: {
      // mandatoryCount is the number of mandatory questions
      // one time update
      mandatoryCount: 0,
      mandatoryAnswered: [],
    },
    goals: {
      mandatoryCount: 0,
      mandatoryAnswered: [],
    },
    competency: {
      mandatoryCount: 0,
      mandatoryAnswered: [],
    },
  },

  // Info about the user, the logged in user is viewing the form
  // Who is this review to?
  // Alias to reviewee details
  reviewToInfo: null,
  // Alias to reviewee id
  reviewToId: null,

  // the logged in user type info
  // Alias to reviewerTypeInfo
  reviewWriterInfo: null,

  reviewTabsData: null,
  selectedReviewTab: null,
};

const form = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_IS_REVIEW_SUBMITTED: {
      return {
        ...state,
        isReviewSubmitted: action.payload,
      };
    }

    case UPDATE_IS_USER_SUBMITTING: {
      return {
        ...state,
        isUserSubmitting: action.payload,
      };
    }

    case UPDATE_REVIEW_FORM_DRAFT_STATUS: {
      return {
        ...state,
        draftStatus: action.payload,
      };
    }

    case UPDATE_IS_VALIDATION_ERROR: {
      return {
        ...state,
        isValidationError: action.payload,
      };
    }

    case UPDATE_SECTION_LIST: {
      return {
        ...state,
        sectionList: action.payload,
      };
    }

    case UPDATE_SECTION_DATA: {
      return {
        ...state,
        sectionData: action.payload,
      };
    }

    case UPDATE_MANDATORY_COUNT: {
      const { type, value } = action.payload;

      return {
        ...state,
        blockInfo: {
          ...state.blockInfo,
          [type]: {
            ...state.blockInfo[type],
            mandatoryCount: value,
          },
        },
      };
    }

    // Might be an array update
    case UPDATE_MANDATORY_ANSWERED: {
      const { type, value } = action.payload;

      return {
        ...state,
        blockInfo: {
          ...state.blockInfo,
          [type]: {
            ...state.blockInfo[type],
            mandatoryAnswered: value,
          },
        },
      };
    }

    case UPDATE_REVIEW_TO_INFO: {
      return {
        ...state,
        reviewToInfo: action.payload,
      };
    }

    case UPDATE_REVIEW_TO_ID: {
      return {
        ...state,
        reviewToId: action.payload,
      };
    }

    case UPDATE_REVIEW_WRITER_INFO: {
      return {
        ...state,
        reviewWriterInfo: action.payload,
      };
    }

    // Use to update calculated_question, overall goal score and overall competency score
    case UPDATE_CALCULATED_SCORE: {
      const { value } = action.payload;

      const sectionDataCopy = { ...state.sectionData };

      Object.keys(value).forEach((key) => {
        sectionDataCopy[key] = {
          ...sectionDataCopy[key],
          score: value[key].score,
          legend: value[key].legend,
        };
      });

      return {
        ...state,
        sectionData: sectionDataCopy,
      };
    }

    case UPDATE_REVIEW_TABS_DATA: {
      return {
        ...state,
        reviewTabsData: action.payload,
      };
    }

    case UPDATE_SELECTED_REVIEW_TAB: {
      return {
        ...state,
        selectedReviewTab: action.payload,
      };
    }

    case UPDATE_IS_FETCHING_REVIEW_FORM_TABS: {
      return {
        ...state,
        isFetchingReviewFormTabs: action.payload,
      };
    }

    case UPDATE_IS_FETCHING_REVIEW_FORM: {
      return {
        ...state,
        isFetchingReviewForm: action.payload,
      };
    }

    case RESET_REVIEW_FORM: {
      return INITIAL_STATE;
    }

    default:
      return state;
  }
};

export default form;
